import { createApiSlice } from "@common";
import { CRUD_COMPETITOR_ROLE } from "@routes";

const apiConfig = [
  {
    name: "addCompetitorRole",
    method: "post",
    url: CRUD_COMPETITOR_ROLE,
    stateKey: "message",
  },
  {
    name: "getCompetitorRole",
    method: "get",
    url: CRUD_COMPETITOR_ROLE,
    stateKey: "data",
  },
  {
    name: "updateCompetitorRole",
    method: "put",
    url: CRUD_COMPETITOR_ROLE,
    stateKey: "message",
  },
  {
    name: "deleteCompetitorRole",
    method: "delete",
    url: CRUD_COMPETITOR_ROLE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"competitorRole",
 apiConfig, 
 customReducers);
const competitorRoleSlice = slice;

export default competitorRoleSlice.reducer;

export const {
  addCompetitorRole,
  getCompetitorRole,
  updateCompetitorRole,
  deleteCompetitorRole,
} = thunks;

export const { rowSelect } = actions;
